export const createImportColumn = ({
  data,
  selectedItems,
  setSelectedItems,
  handleSwitchToggle,
}) => ({
  accessorKey: "exists",
  header: () => {
    const importableRows = data?.data?.filter((item) => !item.exists) || [];
    const allSelected =
      importableRows.length > 0 &&
      importableRows.every((item) => selectedItems[item.Id]);

    return (
      <div className="form-check">
        <span>Import</span>
        <input
          className="form-check-input"
          type="checkbox"
          checked={allSelected}
          onChange={(e) => {
            const checked = e.target.checked;
            const updated = {};
            importableRows.forEach((item) => {
              updated[item.Id] = checked;
            });
            setSelectedItems(updated);
          }}
        />
      </div>
    );
  },
  cell: ({ getValue, row }) => {
    const exists = getValue();
    if (exists) return null;
    const isSelected = selectedItems[row.original.Id] || false;

    return (
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          checked={isSelected}
          onChange={() => handleSwitchToggle(row.original.Id)}
        />
      </div>
    );
  },
});
